import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import {
  FETCH_BOOKINGS_REQUEST,
  UPDATE_CANCEL_BOOKING_REQUEST,
  UPDATE_CHECKED_BOOKING_REQUEST,
} from "./constants";
import { Action, BookingItems } from "./types";

function items(state: BookingItems = [], action: Action): BookingItems {
  let selectBooking = null;
  switch (action.type) {
    case getSuccessActionType(FETCH_BOOKINGS_REQUEST):
      return action.payload.data;

    case UPDATE_CANCEL_BOOKING_REQUEST:
      selectBooking = state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...booking,
              isFetching: true,
            }
          : booking
      );
      return selectBooking;
    case getFailureActionType(UPDATE_CANCEL_BOOKING_REQUEST):
      selectBooking = state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...booking,
              isFetching: false,
            }
          : booking
      );
      return selectBooking;
    case getSuccessActionType(UPDATE_CANCEL_BOOKING_REQUEST):
      selectBooking = state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : booking
      );
      return selectBooking;

    case UPDATE_CHECKED_BOOKING_REQUEST:
      selectBooking = state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...booking,
              isFetching: true,
            }
          : booking
      );
      return selectBooking;
    case getFailureActionType(UPDATE_CHECKED_BOOKING_REQUEST):
      selectBooking = state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...booking,
              isFetching: false,
            }
          : booking
      );
      return selectBooking;
    case getSuccessActionType(UPDATE_CHECKED_BOOKING_REQUEST):
      selectBooking = state.map((booking) =>
        booking.id === action.data.bookingId
          ? {
              ...action.payload,
              isFetching: false,
            }
          : booking
      );
      return selectBooking;

    default:
      return state;
  }
}

function pageCount(state = 0, action: Action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_BOOKINGS_REQUEST):
      return action.payload.pageCount;

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_BOOKINGS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_BOOKINGS_REQUEST):
    case getFailureActionType(FETCH_BOOKINGS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const bookings = combineReducers({ items, pageCount, isFetching });
